const allowedOrigins: string[] = (import.meta.env.VITE_ALLOWED_ORIGINS || '')
  .split(',')
  .map((origin: string) => origin.trim())
  .filter(Boolean);

export function isOriginAllowed(targetOrigin: string): boolean {
  try {
    const { origin } = new URL(targetOrigin);

    return allowedOrigins.includes(origin);
  } catch {
    return false;
  }
}
